import { useCallback, useEffect, useState } from "react";
import {
  hasShiftConfigured,
  shiftLabel,
  withinShiftNow,
} from "../shared/lib/userShift";

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("sessionUser") || "null") || {};
  } catch {
    return {};
  }
};

/**
 * Live shift status for the logged-in user. Re-checks every 30s so the UI
 * locks/unlocks when the clock crosses shift boundaries.
 */
export default function useUserShift() {
  const [user, setUser] = useState(readUser);
  const [allowed, setAllowed] = useState(() => withinShiftNow(readUser()));

  const refresh = useCallback(() => {
    const u = readUser();
    setUser(u);
    setAllowed(withinShiftNow(u));
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    const onStorage = (e) => {
      if (!e || e.key === "sessionUser" || e.key == null) refresh();
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", refresh);
    return () => {
      clearInterval(id);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", refresh);
    };
  }, [refresh]);

  return {
    user,
    allowed,
    locked: hasShiftConfigured(user) && !allowed,
    hasShift: hasShiftConfigured(user),
    hoursLabel: shiftLabel(user),
    refresh,
  };
}
